import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import 'vuetify/dist/vuetify.min.css'

Vue.config.productionTip = false
window.axios = axios

axios.interceptors.response.use((response) => {
  if (response.data.code === 466) {
    localStorage.clear()
    location.reload()
  }
  return response
}, (error) => {
  return Promise.reject(error)
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
